import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import MessageInterface from '../../api/MessageInterface';
import ShopInterface from '../../api/ShopInterface';
import InboxMessagesProvider from '../InboxMessagesProvider';
import transformObjectArrayResponse from '../../utils/transformObjectArrayResponse';
import audio from '../../utils/audio';
import DynamicAction from '../../utils/DynamicAction';
import QueryParamProxy from '../../utils/queryParamProxy';
import RouteParamConstants, { PurchaseTypes } from '../../utils/routeParamConstants';
import { messageTypes, rewardTypes } from '../../utils/messageTypes';
import Screens from '../../screens';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import { purchaseActionTriggers } from '../../constants/userActions';
import { fetchGameRooms } from '../../state/query/games/utils';
import NotificationContext from '../../context/NotificationContext';
import { getText, TEXT_KEY } from '../../utils/localization';
/** @typedef {import('../../api/Constants').CollectMessageRewardsResponse} CollectMessageRewardsResponse */

/** @typedef {import('../../api/Constants').RewardInfo} RewardInfo */

var MessageItem = /*#__PURE__*/function (_Component) {
  _inherits(MessageItem, _Component);

  var _super = _createSuper(MessageItem);

  function MessageItem() {
    var _this;

    _classCallCheck(this, MessageItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {};

    _this._deleteMessage = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                audio.onClick();

                try {
                  InboxMessagesProvider.removeMessage(id);
                } catch (e) {
                  console.error(e);
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.sendEvent = function (message) {
      var coinAmount = message.coin_amount;
      var loyaltyAmount = message.loyalty_amount;
      var eventPayload = {
        id: message.message_id,
        type: message.message_type,
        coins: coinAmount.toString(),
        loyalty_points: loyaltyAmount.toString(),
        loyalty_points_before: (_this.props.loyalty - parseInt(loyaltyAmount)).toString(),
        balance_before: (_this.props.coin - parseInt(coinAmount)).toString()
      };
      Logger.sendEvent(EVENT_TYPES.INBOX_MESSAGE_ACTION_CLICKED, eventPayload);
      Logger.setActionTrigger('inboxMessage');

      if (_this.state.message.action === 'gotoStore') {
        var trigger = Logger.getActionTrigger();
        var _eventPayload = {
          balance_before: _this.props.coin.toString(),
          type: 'regular',
          trigger: trigger || ''
        };
        Logger.sendEvent(EVENT_TYPES.STORE_OPENED, _eventPayload);
      }
    };

    _this._collectRewardHandler = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(message, type) {
        var _QueryParamProxy$setQ2, productSku, payload, sneakPeekGameId, collectResponse, sneakPeakAction;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                audio.onClick();

                if (!(type === messageTypes.VIP_PASS && _this.props.unlimitedVipAccess)) {
                  _context2.next = 4;
                  break;
                }

                QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.VipAccessFlow));
                return _context2.abrupt("return");

              case 4:
                if (!(type === messageTypes.OFFER)) {
                  _context2.next = 9;
                  break;
                }

                productSku = message.cpil_id;
                QueryParamProxy.setQueryParams((_QueryParamProxy$setQ2 = {}, _defineProperty(_QueryParamProxy$setQ2, RouteParamConstants.PARAM_MODAL, Screens.Shop), _defineProperty(_QueryParamProxy$setQ2, RouteParamConstants.PARAM_PURCHASE_SKU, productSku), _defineProperty(_QueryParamProxy$setQ2, RouteParamConstants.PARAM_PURCHASE_TYPE, PurchaseTypes.CURRENCY), _defineProperty(_QueryParamProxy$setQ2, RouteParamConstants.PARAM_PURCHASE_NAME, message.subject), _defineProperty(_QueryParamProxy$setQ2, RouteParamConstants.PARAM_OFFER_ENABLE, true), _defineProperty(_QueryParamProxy$setQ2, RouteParamConstants.PARAM_OFFER_DETAIL, {
                  sku: productSku,
                  name: message.subject,
                  type: PurchaseTypes.CURRENCY,
                  amount: message.coins,
                  price: message.price,
                  messageId: message.message_id,
                  cpil_id: message.cpil_id
                }), _QueryParamProxy$setQ2));
                Logger.setActionTrigger(purchaseActionTriggers.PERSONALIZED_OFFER_BUY_BUTTON);
                return _context2.abrupt("return");

              case 9:
                _context2.prev = 9;

                /** @type {CollectMessageRewardsResponse} */
                payload = {
                  messageId: message.message_id
                };

                if (type === messageTypes.SNEAK_PEEK) {
                  sneakPeekGameId = message.action && message.action.split(':')[1];
                  payload.gameId = sneakPeekGameId;
                }

                _context2.next = 14;
                return MessageInterface.collectMessageRewards(payload);

              case 14:
                collectResponse = _context2.sent;

                if (!collectResponse.success) {
                  _context2.next = 34;
                  break;
                }

                audio.playCoinSfx();
                _context2.t0 = type;
                _context2.next = _context2.t0 === messageTypes.VIP_PASS ? 20 : _context2.t0 === messageTypes.SNEAK_PEEK ? 25 : 28;
                break;

              case 20:
                fetchGameRooms(true);
                ShopInterface.refreshActiveConsumables();

                _this.props.setPurchaseType(rewardTypes.VIP_ROOM_ACCESS);

                _this._dynamicActionHandler(message.action);

                return _context2.abrupt("break", 31);

              case 25:
                sneakPeakAction = "sneakPeek:".concat(sneakPeekGameId, ",").concat(collectResponse.reward_info.sneakPeekEndDate);

                _this._dynamicActionHandler(sneakPeakAction);

                return _context2.abrupt("break", 31);

              case 28:
                collectResponse.reward_info = transformObjectArrayResponse(collectResponse.reward_info);

                _this.context.addNotification({
                  message: "".concat(getText(TEXT_KEY.REDEEM_MESSAGE_CONGRATS), " \r\n ").concat(collectResponse.reward_info.map(function (reward) {
                    return "".concat(reward.amount, " ").concat(reward.currency);
                  }), " ").concat(getText(TEXT_KEY.REDEEM_MESSAGE_CONGRATS_TEXT)),
                  title: getText(TEXT_KEY.REWARD_INFO),
                  button: getText(TEXT_KEY.OK),
                  hideHelpButton: true
                });

                return _context2.abrupt("break", 31);

              case 31:
                InboxMessagesProvider.removeMessage(message.message_id, false);
                _context2.next = 35;
                break;

              case 34:
                _this.context.addNotification({
                  message: collectResponse.error || getText(TEXT_KEY.DEFAULT_ERROR_MESSAGE),
                  title: getText(TEXT_KEY.GENERIC_MESSAGE_ERROR),
                  button: getText(TEXT_KEY.OK)
                });

              case 35:
                _context2.next = 40;
                break;

              case 37:
                _context2.prev = 37;
                _context2.t1 = _context2["catch"](9);

                _this.context.addNotification({
                  message: getText(TEXT_KEY.DEFAULT_ERROR_MESSAGE),
                  title: getText(TEXT_KEY.GENERIC_MESSAGE_ERROR),
                  button: getText(TEXT_KEY.OK)
                });

              case 40:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[9, 37]]);
      }));

      return function (_x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this._dynamicActionHandler = function (action) {
      audio.onClick();
      DynamicAction.getActionCallback(action, _this.props.navigation)();
    };

    return _this;
  }

  _createClass(MessageItem, [{
    key: "render",
    value: function render() {
      return this.props.render({
        deleteMessage: this._deleteMessage,
        dynamicActionHandler: this._dynamicActionHandler,
        collectRewardHandler: this._collectRewardHandler
      });
    }
  }]);

  return MessageItem;
}(Component);

MessageItem.contextType = NotificationContext;
export { MessageItem as default };